import React from 'react';

import { InternalLink } from '../Clickables/InternalLink/InternalLink';
import { ChevronRightIcon } from '../Icons/ChevronRightIcon';

import { BreadcrumbsSchema } from './BreadcrumbsSchema';

export interface IBreadcrumbItem {
  label: string;
  link?: string;
}

interface IProps {
  items: IBreadcrumbItem[];
  className?: string;
  color?: 'black' | 'abyss';
}

export const Breadcrumbs = ({ items, className = '', color = 'black' }: IProps) => (
  <>
    <BreadcrumbsSchema items={items} />
    <ol className={`flex list-none flex-row gap-x-2 py-4 ${className}`} data-testid="Breadcrumbs">
      {items.map((item, index) => (
        <li
          key={`${index}-${item.label.replace(/ /g, '-')}`}
          className={`body-text-md text-${color} mb-0 flex h-4 items-center`}
        >
          {item.link ? (
            <InternalLink variant="textNone" to={item.link} className="w-max hover:underline">
              {item.label}
            </InternalLink>
          ) : (
            item.label
          )}
          {index !== items.length - 1 && (
            <span className="ml-2">
              <ChevronRightIcon width={16} height={16} />
            </span>
          )}
        </li>
      ))}
    </ol>
  </>
);
